module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM20 28H4V4h16v24zm-7.1-17.754c-.444-.426-.9-.286-.9.316V14H7.05C6.5 14 6 14.448 6 15v2c0 .552.5 1 1.05 1H12v3.438c0 .602.424.742.87.318l4.814-4.986c.446-.426.376-1.114-.066-1.54L12.9 10.246z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/slide-out-right-1.js
// module id = 1419
// module chunks = 14